import React from 'react'


import SvgArrowUpDown from '../../../../../../components/SVG/ArrowUpDown'
import { cl } from '../../../../../../utilities/cl'
import { connect } from 'react-redux'


const TableHeader_Sort = ({ sort_field, sort }) => {
    return (
        <sections className="Songs">
            <header className="Songs__control">
                <div className="Songs__grid">
                    <div className={cl("id", { "Songs__grid--active": sort_field === 'id' })}>
                        <button
                            className="spp-btn spp-btn_string"
                            onClick={() => sort("id")}
                            style={{marginRight:0}}
                        >
                            <SvgArrowUpDown className="spp-svg" />
                            ID
                        </button>
                    </div>
                    <div
                        className={cl("composition_video", { "Songs__grid--active": sort_field === 'name' })}
                        style={{
                            width: 200,
                            marginLeft: 20
                        }}
                    >
                        <button
                            className="spp-btn spp-btn_string"
                            onClick={() => sort("name")}

                        >
                            <SvgArrowUpDown
                                className="spp-svg"
                            />
                            ПРОИЗВЕДЕНИЕ
                        </button>
                    </div>
                    <div className={cl("duration_video", { "Songs__grid--active": sort_field === 'cliptime' })}>

                        <button
                            className="spp-btn spp-btn_string"
                            onClick={() => sort("cliptime")}
                            style={{
                                marginRight: 0
                            }}
                        >
                            <SvgArrowUpDown className="spp-svg" />
                            ДЛИТЕЛЬНОСТЬ
                        </button>
                    </div>
                    <div className="type_video">
                        <button
                            className="spp-btn spp-btn_string"

                        >
                            <SvgArrowUpDown className="spp-svg" />
                            ТИП
                        </button>
                    </div>
                    <div
                     className={cl("added_video", { "Songs__grid--active": sort_field === 'ctime' })}
                            style={{
                                marginRight: 25
                            }}
                     >
                        <button
                            className="spp-btn spp-btn_string"
                            onClick={() => sort("ctime")}
                        >
                            <SvgArrowUpDown className="spp-svg" />
                            ДОБАВЛЕНО
                        </button>
                    </div>
                </div>
            </header>
        </sections>
    )
}


const stateToProps = state => ({
    sort_field: state.videolists.assocPublicTracksTable.sort_field

})
const actionsToProps = {

}

export default connect(stateToProps, actionsToProps)(TableHeader_Sort)